import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

export const INVENTARIO_MENU: AppMenuItem = {
  "label": "Inventario",
  "visible": true,
  "children": [
    {
      "label": "Correción Existencias",
      "children": [
        {
          "ambientes": [
            AmbienteEnum.Desarrollo,
            AmbienteEnum.Calidad,
            AmbienteEnum.Capacitacion,
            AmbienteEnum.Produccion
          ],
          "sociedades": [
            SociedadEnum.SC
          ],
          "route": "inventario/correccion-existencias",
          "proceso": MENU_PERMISSIONS.correccionExistencia,
          "label": "Correción Existencias",
          "tipoPuntoVenta": [
            TipoPuntoVentaEnum.PuntoVentaPropio,
            TipoPuntoVentaEnum.Franquicias
          ],
          "visible": true
        },
        {
          "ambientes": [
            AmbienteEnum.Desarrollo,
            AmbienteEnum.Calidad,
            AmbienteEnum.Capacitacion,
            AmbienteEnum.Produccion
          ],
          "sociedades": [
            SociedadEnum.SC
          ],
          "route": "inventario/consulta-correccion-existencias",
          "proceso": MENU_PERMISSIONS.consultaCorreccion,
          "label": "Consulta",
          "tipoPuntoVenta": [
            TipoPuntoVentaEnum.Corporativo
          ],
          "visible": true
        }
      ]
    }
  ]
};
